module.exports = __webpack_public_path__ + "img/9-8.18696b15.jpg";